import axios from 'axios';

const schoolStore = {
    namespaced: true,
    state: {
        // allschools:  all schools in the salesforce
        // active schools: all  public and some other criteria of all schools
        allSchools: [],
        activeSchools: [],
        independentschools: [],
        schooltype: "",
        schoolid: "",
        logo_base64: "",
        searchSchoolsResults: [],
        searchSchoolsCancelTokenSource: axios.CancelToken.source(),
        searchSchoolCancel: true,

        searchAttendedSchoolsResults: [],
        searchAttendedSchoolsCancelTokenSource: axios.CancelToken.source(),
        searchAttendedSchoolsCancel: true,

        searchIntendedSchoolsResults:[],
        searchIntendedSchoolsCancelTokenSource: axios.CancelToken.source(),    
        searchIntendedSchoolsCancel: true,    
        /*
        allPrimarySchools: [],
        PrimaryPublicSchools: [],
        PrimaryIndependentSchools: [],
        */
    },
    actions: {
        async searchSchools({commit, state, rootGetters}, query) {
            state.searchSchoolsCancelTokenSource = axios.CancelToken.source();
            try {
                const res = await fetchCancellableData(`/api/schools?schoolnamekeyword=${query}&schooltype=12&schoollevel=12`, state.searchSchoolsCancelTokenSource.token, rootGetters['user/token'])
                if (res.status === 200) {
                    state.searchSchoolCancel = false;
                    commit("updateSearchSchoolsResults", res.data.map(s => ({value: s.Id, text: s.Name})));
                }
                return (res.status === 200);
            } catch(error) {
                if (axios.isCancel(error)) {
                    state.searchSchoolCancel = true;
                  } else {
                    // handle error
                  }
            }
        },
        async searchAttendedSchools({commit, state, rootGetters}, query) {
            state.searchAttendedSchoolsCancelTokenSource = axios.CancelToken.source();
            try {
                const res = await fetchCancellableData(`/api/schools?schoolnamekeyword=${query}&schooltype=12&schoollevel=12`, state.searchAttendedSchoolsCancelTokenSource.token, rootGetters['user/token']);
                if (res.status === 200) {
                    state.searchAttendedSchoolsCancel = false;
                    commit("updateSearchAttendedSchoolsResults", res.data.map(s => ({value: s.Id, text: s.Name})));
                }
                return (res.status === 200);
            } catch(error) {
                if (axios.isCancel(error)) {
                    state.searchAttendedSchoolsCancel = true;
                } else {
                  // handle error
                }
            }
        },
        async searchIntendedSchools({commit, state, rootGetters}, {query, schoolType, schoolLevel}) {
            state.searchIntendedSchoolsCancelTokenSource = axios.CancelToken.source();
            try {
                const res = await fetchCancellableData(`/api/schools?schoolnamekeyword=${query}&schooltype=${schoolType}&schoollevel=${schoolLevel}`, state.searchIntendedSchoolsCancelTokenSource.token, rootGetters['user/token']);
                if (res.status === 200) {
                    state.searchIntendedSchoolsCancel = false;
                    commit("updateSearchIntendedSchoolsResults", res.data.map(s => ({value: s.Id, text: s.Name})));
                }
                return (res.status === 200);
            } catch(error) {
                if (axios.isCancel(error)) {
                    state.searchIntendedSchoolsCancel = true;
                } else {
                  // handle error
                }
            }
        },
        async fetchSchoolIdAndNameById({rootGetters}, schid) {
            try {
                const res = await pullSchools(`/api/schools?id=${schid}`, rootGetters['user/token'])
                if(res.status === 200) {
                    return {value: res.data.Id, text: res.data.Name};
                } 
            } catch(e) {
                console.log(e);
            }
        },
        async fetchSchools({commit, state, rootGetters, dispatch}, count=0) {
            if(count === 3) {
                return;
            }
            if(state && state.allSchools.length > 0) {
                return;
            }
            try {
                const res = await pullSchools(`/api/schools`, rootGetters['user/token'])
                if(res.status === 200) {
                    commit('updateSchools', res.data.map(s => ({value: s.Id, text: s.Name})));
                } else {
                    dispatch('fetchSchools', count+1);
                }
            } catch(e) {
                console.log(e);
                dispatch('fetchSchools', count+1);
            }
        },
        async fetchActiveSchools({commit, state, rootGetters, dispatch}, count=0) {
            if(count === 3) {
                return;
            }
            if(state && state.activeSchools.length > 0) return;
            try {
                const res = await pullSchools(`/api/schools?active=1`, rootGetters['user/token'])
                if(res.status === 200) {
                    commit('updateActiveSchools', res.data.map(s => ({value: s.Id, text: s.Name})));
                } else {
                    dispatch('fetchActiveSchools', count+1);
                }
            } catch(e) {
                console.log(e);
                dispatch('fetchActiveSchools', count+1);
            }
        },
        async fetchIndependentSchools({commit, state, rootGetters, dispatch}, count=0) {
            if(count === 3) {
                return;
            }
            if(state && state.independentschools.length > 0) {
                return;
            }
            try {
                const res = await pullSchools(`/api/schools?independent=1`, rootGetters['user/token'])
                //const res = await pullSchools(`/api/schools?active=0`, rootGetters['user/token'])

                if(res.status === 200) {
                    commit('updateIndependentSchools', res.data.map(s => ({value: s.Id, text: s.Name})));
                } else {
                    dispatch('fetchIndependentSchools', count+1);
                }
            } catch(e) {
                console.log(e);
                dispatch('fetchIndependentSchools', count+1);
            }
        },
        async fetchSchooltype({commit, rootGetters}, {schid}) {
            try {
                
                const res = await pullSchools(`/api/schools/${schid}`, rootGetters['user/token'])
                if(res.status === 200) {
                    commit('updateSchooltype', res.data['type']);
                    console.log(res.data['type']);
                } 
            } catch(e) {
                console.log(e);
            }
        },
        async fetchAllPrimarySchools({commit, state, rootGetters, dispatch}, count=0) {
            if(count === 3) {
                return;
            }
            if(state && state.allSchools.length > 0) {
                return;
            }
            try {
                const res = await pullSchools(`/api/schools?schoollevel=1`, rootGetters['user/token'])
                //const res = await pullSchools(`/api/schools?active=0`, rootGetters['user/token'])

                if(res.status === 200) {
                    commit('updateSchools', res.data.map(s => ({value: s.Id, text: s.Name})));
                } else {
                    dispatch('fetchAllPrimarySchools', count+1);
                }
            } catch(e) {
                console.log(e);
                dispatch('fetchAllPrimarySchools', count+1);
            }
        },
        async fetchPrimaryPublicSchools({commit, state, rootGetters, dispatch}, count=0) {
            if(count === 3) {
                return;
            }
            if(state && state.activeSchools.length > 0) {
                return;
            }
            try {
                const res = await pullSchools(`/api/schools?schoollevel=1&schooltype=1`, rootGetters['user/token'])
                //const res = await pullSchools(`/api/schools?active=0`, rootGetters['user/token'])

                if(res.status === 200) {
                    commit('updateActiveSchools', res.data.map(s => ({value: s.Id, text: s.Name})));
                } else {
                    dispatch('fetchPrimaryPublicSchools', count+1);
                }
            } catch(e) {
                console.log(e);
                dispatch('fetchPrimaryPublicSchools', count+1);
            }
        },
        async fetchPrimaryindependentSchools({commit, state, rootGetters, dispatch}, count=0) {
            if(count === 3) {
                return;
            }
            if(state && state.independentschools.length > 0) {
                return;
            }
            try {
                const res = await pullSchools(`/api/schools?schoollevel=1&schooltype=2`, rootGetters['user/token'])
                //const res = await pullSchools(`/api/schools?active=0`, rootGetters['user/token'])

                if(res.status === 200) {
                    commit('updateIndependentSchools', res.data.map(s => ({value: s.Id, text: s.Name})));
                } else {
                    dispatch('fetchPrimaryindependentSchools', count+1);
                }
            } catch(e) {
                console.log(e);
                dispatch('fetchPrimaryindependentSchools', count+1);
            }
        },
        async fetchSchoolLogo({commit, state, rootGetters, dispatch}, count=0) {
            if(count === 3) {
                return;
            }
            console.log('into fetch school logo');
            try {
                console.log('before call api ' + state.schoolid);
                let logoString = '/api/schools?logo=' + state.schoolid;
                const res = await pullSchools(logoString, rootGetters['user/token'])
                //const res = await pullSchools(`/api/schools?active=0`, rootGetters['user/token'])

                if(res.status === 200) {
                    commit('updateSchoolLogoString', res.data);
                    console.log('fetch logo finish');
                } else {
                    dispatch('fetchSchoolLogo', count+1);
                }
            } catch(e) {
                console.log(e);
                dispatch('fetchSchoolLogo', count+1);
            }
        },
    },
    mutations: {
        updateSearchSchoolsResults(state, results) {
            state.searchSchoolsResults = results;
        },
        updateSearchAttendedSchoolsResults(state, results) {
            state.searchAttendedSchoolsResults = results;
        },
        updateSearchIntendedSchoolsResults(state, results) {
            state.searchIntendedSchoolsResults = results;
        },
        cancelSearchSchoolsRequest(state) {
            state.searchSchoolsCancelTokenSource.cancel();
        },
        cancelSearchAttendedSchoolsRequest(state) {
            state.searchAttendedSchoolsCancelTokenSource.cancel();
        },
        cancelSearchIntendedSchoolsRequest(state) {
            state.searchIntendedSchoolsCancelTokenSource.cancel();
        },
        updateSchools(state, schools) {
            state.allSchools = schools;
        },
        updateActiveSchools(state, schools) {
            state.activeSchools = schools;
        },
        updateIndependentSchools(state, schools) {
            state.independentschools = schools;
            //console.log(state.independentschools);
        },
        updateSchooltype(state, schools) {
            state.schooltype = schools;
        },
        updateSchoolLogo(state, school_id) {
            if(state && school_id != state.schoolid){
                state.schoolid = school_id;
            }
        },
        async updateSchoolLogoString(state, Base64String) {
            state.logo_base64 = Base64String;
            console.log('Base64 String get!' + state.logo_base64);
        },
        /*
        updateallPrimarySchools(state, schools) {
            state.allPrimarySchools = schools;
            console.log('trigger allPrimarySchools ' + state.schooltype);
        },
        updatePrimaryPublicSchools(state, schools) {
            state.PrimaryPublicSchools = schools;
            console.log('trigger PrimaryPublicSchools ' + state.schooltype);
        },
        updatePrimaryIndependentSchools(state, schools) {
            state.PrimaryIndependentSchools = schools;
            console.log('trigger PrimaryIndependentSchools ' + state.schooltype);
        }
        */
    },
    getters: {
        searchSchoolsResults: state => {
            return state.searchSchoolsResults;
        },
        searchAttendedSchoolsResults: state => {
            return state.searchAttendedSchoolsResults;
        },
        searchIntendedSchoolsResults: state => {
            return state.searchIntendedSchoolsResults;
        },
        searchSchoolCancel: state => state.searchSchoolCancel,
        searchAttendedSchoolsCancel: state => state.searchAttendedSchoolsCancel,
        searchIntendedSchoolsCancel: state => state.searchIntendedSchoolsCancel,
        allSchools: state => {
            return state.allSchools;
        },
        activeSchools: state => {
            return state.activeSchools;
        },
        independentSchools: state => {
            return state.independentschools;
        },
        schooltype: state => {
            return state.schooltype;
        },
        schoollogo: state => {
            console.log('get base64 from store');
            return state.logo_base64;
        },
    }
}

function fetchCancellableData(url, cancelToken, token) {
    return axios.get( url,
        {
            cancelToken: cancelToken
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }
    )
}

function pullSchools(url, token) {
    return axios.get( url,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }
    )
}

export default schoolStore;
